var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "70px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffde91;}.cls-2{fill:#b5efff;}.cls-3{fill:#f2f6fc;}.cls-4{fill:#9196aa;}.cls-5{fill:#cdd2e1;}.cls-6{fill:#ffac5a;}.cls-7{fill:#80dbff;}.cls-8{fill:#190402;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02-setting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02-setting",
    "data-name": "02-setting"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 18,
    width: 6,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33,
    y: 18,
    width: 6,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30,7a6,6,0,0,1-3,5.19V24H21V12.19A5.99,5.99,0,0,1,22,1.35V6a2,2,0,0,0,4,0V1.35A5.991,5.991,0,0,1,30,7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14 4 14 9 10 9 10 4 12 1 14 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39,1V6L37,8H35L33,6V1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10,
    y: 9,
    width: 4,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43,43v4H32a8,8,0,0,0-16,0H5V43h5.33a13.916,13.916,0,0,1,1.89-4.54L8.44,34.69l4.25-4.25,3.77,3.78A13.916,13.916,0,0,1,21,32.33V27h6v5.33a13.916,13.916,0,0,1,4.54,1.89l3.77-3.78,4.25,4.25-3.78,3.77A13.916,13.916,0,0,1,37.67,43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 9,
    y: 18,
    width: 6,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 33,
    y: 18,
    width: 6,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 21,
    y: 21,
    width: 6,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43,42H38.452a14.849,14.849,0,0,0-1.41-3.386L40.266,35.4a1,1,0,0,0,0-1.415l-4.25-4.25a1,1,0,0,0-.707-.293h0a1,1,0,0,0-.708.294l-3.216,3.224A14.849,14.849,0,0,0,28,31.548V27a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1v4.548a14.849,14.849,0,0,0-3.386,1.41L13.4,29.734a1,1,0,0,0-.708-.294h0a1,1,0,0,0-.707.293l-4.25,4.25a1,1,0,0,0,0,1.415l3.224,3.216A14.849,14.849,0,0,0,9.548,42H5a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1,7,7,0,0,1,14,0,1,1,0,0,0,1,1H43a1,1,0,0,0,1-1V43A1,1,0,0,0,43,42Zm-1,4H32.945a9,9,0,0,0-17.89,0H6V44h4.33a1,1,0,0,0,.977-.786A12.877,12.877,0,0,1,13.062,39a1,1,0,0,0-.136-1.248L9.855,34.689l2.834-2.834,3.063,3.071A1,1,0,0,0,17,35.062a12.877,12.877,0,0,1,4.214-1.755A1,1,0,0,0,22,32.33V28h4v4.33a1,1,0,0,0,.786.977A12.877,12.877,0,0,1,31,35.062a1,1,0,0,0,1.248-.136l3.063-3.071,2.834,2.834-3.071,3.063A1,1,0,0,0,34.938,39a12.877,12.877,0,0,1,1.755,4.214A1,1,0,0,0,37.67,44H42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.293,8.707A1,1,0,0,0,35,9v8H31v2h1v4h2V19h4V30h2V19h1V17H37V9a1,1,0,0,0,.707-.293l2-2A1,1,0,0,0,40,6V1a1,1,0,0,0-1-1H33a1,1,0,0,0-1,1V6a1,1,0,0,0,.293.707ZM34,2h4V5.586L36.586,7H35.414L34,5.586Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20,12.737V24h2V12.19a1,1,0,0,0-.5-.865,4.99,4.99,0,0,1-.5-8.32V6a3,3,0,0,0,6,0V3.005a4.99,4.99,0,0,1-.5,8.32,1,1,0,0,0-.5.865V24h2V12.737A6.988,6.988,0,0,0,26.332.407,1,1,0,0,0,25,1.35V6a1,1,0,0,1-2,0V1.35A1,1,0,0,0,21.668.407,6.988,6.988,0,0,0,20,12.737Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 32,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 14,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8,30h2V19h4v4h2V19h1V17H15V4a1.006,1.006,0,0,0-.168-.555l-2-3a1.039,1.039,0,0,0-1.664,0l-2,3A1.006,1.006,0,0,0,9,4V17H7v2H8ZM12,2.8l1,1.5V8H11V4.3ZM11,10h2v7H11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4b9b558151c23b57d917eb1053154b5f.svg";
export { ForwardRef as ReactComponent };